import React, { useEffect } from "react";
import { Route, Switch } from 'react-router';
import NavMenu from './common/NavMenu';
import { connect } from "react-redux";
import { setupNavigation } from "../redux/actions/navItemsActions";
import PropTypes from "prop-types";
import "./Home.css";

function Contact({ setupNavigation }) {

    const navigationItems =
    {
        sections: [{
            name: 'Admin',
            items: [
                {
                    path: '/about',
                    text: 'About JustGoRide',
                    icon: 'fas fa-info-circle'
                },
                {
                    path: '/about/contact',
                    text: 'Contact',
                    icon: 'far fa-at'
                },
                {
                    path: '/about/termsandconditions',
                    text: 'Terms and Conditions',
                    icon: 'fas fa-file-signature'
                },
                {
                    path: '/about/privacypolicy',
                    text: 'Privacy Policy',
                    icon: 'fas fa-user-secret'
                }
            ]
        }]
    };

    useEffect(() => {
        document.title = "Terms and Conditions | JustGoRide";
        setupNavigation(navigationItems);

    }, []);

    return (
        <div className="policy row justify-content-center mt-4">
            <div className="col-10  text-center">
                <img className="about-logo" alt="JustGoRide" src="/resources/images/new-email-logo.png" />
                <div className="page-content-head text-center  mb-5">
                    <h2><span className="head-icon far fa-at"></span> Get in Touch</h2>
                </div>
                <p>
                    If your have any questions or suggestions for improvements to JustGoRide please feel free
                    to drop us a message and we'll do our best to get back to you as soon as possible.
                 </p>
                <p>
                    Our email address is <b>admin@justgoride.co.uk</b>.
                </p>
            </div>
        </div>
    );
}

Contact.propTypes = {
    setupNavigation: PropTypes.func.isRequired
}


function mapStateToProps(state) {
    return {
    };
}

const mapDispatchToProps = {
    setupNavigation
}

export default connect(mapStateToProps, mapDispatchToProps)(Contact);   


// WEBPACK FOOTER //
// ./src/components/Contact.js